export const handleShiftKeySelection = ({
    event,
    currentRowIndex,
    initialRowIndex,
    pageLength,
    selectRowHandler,
    setCurrentRowIndex,
  }) => {
    if (event.shiftKey && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
      event.preventDefault();
  
      let newIndex = currentRowIndex;
  
      if (event.key === "ArrowUp" && currentRowIndex > 0) {
        newIndex = currentRowIndex - 1;
        selectRowHandler(newIndex < initialRowIndex ? newIndex : currentRowIndex);
      }
  
      if (event.key === "ArrowDown" && currentRowIndex < pageLength - 1) {
        newIndex = currentRowIndex + 1;
        selectRowHandler(newIndex > initialRowIndex ? newIndex : currentRowIndex);
      }
  
      setCurrentRowIndex(newIndex);
    }
  };
  